import * as AiIcons from "react-icons/ai";
import google_logo from "../assets/google-logo.png";
import linkedin_logo from "../assets/linkedin.png";
import pipl_logo from "../assets/pipl.png";
import combine_logo from "../assets/combine.png";
import global_search_logo from "../assets/global-search.png"
import startup from "../assets/startup.png"
import mca from "../assets/mca.png"
import website from "../assets/website.png"
import elasticsearch from "../assets/elasticsearch.png"
import job_logo from "../assets/job_logo.png"
import dnb_logo from "../assets/dnb_logo.png"

const api_list = [
  {
    id: 0,
    name: "Home",
    title: "Home",
    desc: "Dashboard",
    path: "/dashboard",
    icon: <AiIcons.AiFillHome />,
    cName: "nav-text",
    logo: google_logo
  },
  {
    id: 1,
    name: "Local Result",
    title: "Local Result",
    desc: "Enter location and query for google search",
    path: "/api/local_result",
    icon: <AiIcons.AiFillGoogleCircle />,
    cName: "nav-text",
    logo: google_logo
  },
  {
    id: 2,
    name: "Map result",
    title: "Map Result",
    desc: "Enter location and query for google search",
    path: "/api/map_result",
    icon: <AiIcons.AiFillGoogleCircle />,
    cName: "nav-text",
    logo: google_logo
  },
  {
    id: 4,
    name: "PIPL",
    title: "PIPL",
    desc: "Upload file and get results from PIPL",
    path: "/api/pipl",
    icon: <AiIcons.AiFillLinkedin />,
    cName: "nav-text",
    logo: pipl_logo
  },
  {
    id: 5,
    name: "CSV combiner",
    title: "CSV combiner",
    desc: "Upload files to combine and remove duplicates",
    path: "/api/csv_combiner",
    icon: <AiIcons.AiTwotoneFileExcel />,
    cName: "nav-text",
    logo: combine_logo
  },
  {
    id: 7,
    name: "GST",
    title: "GST",
    desc: "Upload file and get gst, cin and company website",
    path: "/api/gst",
    icon: <AiIcons.AiOutlineGlobal />,
    cName: "nav-text",
    logo: global_search_logo
  },
  {
    id: 8,
    name: "Startupindia",
    title: "Startupindia",
    desc: "Get data from www.startupindia.gov.in",
    path: "/api/startupindia",
    icon: <AiIcons.AiOutlineStar />,
    cName: "nav-text",
    logo: startup
  },
  {
    id: 9,
    name: "MCA",
    title: "MCA",
    desc: "Get data from https://www.mca.gov.in",
    path: "/api/mca",
    icon: <AiIcons.AiFillBuild />,
    cName: "nav-text",
    logo: mca
  },
  {
    id: 10,
    name: "Linkedin url",
    title: "Linkedin url",
    desc: "Upload file and get linkedin urls",
    path: "/api/linkedin_url_fast",
    icon: <AiIcons.AiFillLinkedin />,
    cName: "nav-text",
    logo: linkedin_logo
  },
  {
    id: 11,
    name: "Website",
    title: "Website",
    desc: "Upload file and get website of company",
    path: "/api/company_website",
    icon: <AiIcons.AiOutlineGlobal />,
    cName: "nav-text",
    logo: website
  },
  {
    id: 12,
    name: "Elasticsearch",
    title: "Elasticsearch",
    desc: "Upload file and get data from Elasticsearch",
    path: "/api/elasticsearch",
    icon: <AiIcons.AiFillDatabase />,
    cName: "nav-text",
    logo: elasticsearch
  },
  {
    id: 13,
    name: "Jobs Scraper",
    title: "Jobs Scraper",
    desc: "scrapes data from naukri , simplyhired or indeed",
    path: "/api/jobs_scraper",
    icon: <AiIcons.AiOutlineGlobal />,
    cName: "nav-text",
    logo: job_logo
  },
  {
    id: 14,
    name: "D&B Scraper",
    title: "D&B Scraper",
    desc: "scrapes company data from d&b directory",
    path: "/api/dnb_scraper",
    icon: <AiIcons.AiOutlineGlobal />,
    cName: "nav-text",
    logo: dnb_logo
  },
  {
    id: 15,
    name: "Apollo Email",
    title: "Apollo Email Finder",
    desc: "Get email addresses from LinkedIn URLs using Apollo API",
    path: "/api/apollo_email",
    icon: <AiIcons.AiFillMail />,
    cName: "nav-text",
    logo: linkedin_logo
  },
  {
    id: 16,
    name: "CIN PLC Checker",
    title: "CIN PLC Checker",
    desc: "Identify companies converted from Private to Public using CINs",
    path: "/api/cin_plc_checker",
    icon: <AiIcons.AiFillCheckCircle />,
    cName: "nav-text",
    logo: mca
  }
];

export default api_list;